module.exports = __webpack_public_path__ + "img/enterprises1.127ea879.png";